<script>
import PageFooter from "@/layouts/PageFooter.vue";
import GlobalUserPopover from "@/components/GlobalUserPopover.vue";

export default {
  name: "GlobalLayout",
  components: {PageFooter, GlobalUserPopover},
  data() {
    return {
      authState: this.$auth.state
    }
  },
  computed: {
    // 方法：根据全局登录态切换导航右侧入口
    isLoggedIn() {
      return Boolean(this.authState.user && this.authState.user.mobile)
    }
  },
  methods: {
    // 关键节点：将顶部导航定位到首页对应内容区
    scrollToHomeSection(sectionId){
      const target = document.getElementById(sectionId)
      // 逻辑分支：目标区块不存在时直接结束，避免导航点击抛出异常
      if (!target) return
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    toHelperCenter(){
      this.$router.push({ name: 'helperCenter' })
    },
    // 关键节点：免费试用属于权益入口，未登录时先唤起全局登录弹窗
    tryUseFree(){
      this.$auth.requireLogin(() => {
        this.$trial.startTrialFlow()
      })
    },
    goPackageService(){
      this.$router.push('/package-service')
    }
  }
}
</script>

<template>
<div class="global-wrapper">
  <div class="global-header">
    <div class="left">
      <div class="logo">
        <img src="@/assets/images/logo.svg" alt="">
      </div>
    </div>
    <div class="center">
      <div class="menus">
        <div class="menu-item" @click="scrollToHomeSection('product-capability')">产品能力</div>
        <div class="menu-item" @click="scrollToHomeSection('package-selection')">产品方案</div>
        <div class="menu-item" @click="toHelperCenter">帮助中心</div>
      </div>
    </div>
    <div class="right">
      <GlobalUserPopover v-if="isLoggedIn"></GlobalUserPopover>
      <template v-else>
        <div class="web-button" @click="goPackageService">预约产品演示</div>
        <div class="web-button yellow" style="margin-right: 12px;" @click="tryUseFree">立即免费试用</div>
      </template>
    </div>
  </div>
  <div class="global-body">
    <slot></slot>
  </div>
  <div class="global-footer">
    <PageFooter></PageFooter>
  </div>
</div>
</template>

<style scoped lang="less">
.global-wrapper{
  width: 100%;
  .global-header{
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 120px;
    .left{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .logo{
        height: 28px;
        img{
          display: block;
          height: 28px;
        }
      }
    }
    .center{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .menus{
        display: flex;
        padding: 0 80px;
        .menu-item{
          font-family: PingFang SC;
          font-weight: 500;
          margin-right: 40px;
          cursor: pointer;
          color: #333;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .global-footer{
    width: 100%;
    background: #F7F7F7;
  }
}
</style>
